import Button from 'components/shared/Buttons/Button';
import Input from 'components/shared/Input/Input';

const NewSave = ({ saveButton, setSaveButton, saveInput, setSaveInput, save, filtersData }) => {
  if (!saveButton) return null;

  const existingFilters = filtersData.map((filter) => filter.name);
  const isError = existingFilters.includes(saveInput);
  const errorMessage = isError ? 'Filter name already exists' : '';

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center"
      onClick={() => setSaveButton(false)}>
      <div className="absolute inset-0 bg-black opacity-30"></div>
      <div
        className="relative flex w-[230px] flex-col gap-2 rounded-lg bg-white p-4 shadow-lg"
        onClick={(e) => e.stopPropagation()}>
        <Input
          value={saveInput}
          label="Filter name"
          data-qa="filter-name"
          onChange={(e) => setSaveInput(e.target.value)}
          placeholder="Enter filter name"
          error={errorMessage}
        />
        <div className="flex justify-between pt-2">
          <Button
            onClick={() => setSaveButton(false)}
            text="Close"
            size="small"
            data-qa="close"
            outlined
            color="neutral"
          />
          <Button
            onClick={save}
            disabled={isError || !saveInput}
            text="Save"
            size="small"
            icon="save-mono"
            iconColor="white"
            data-qa="save"
          />
        </div>
      </div>
    </div>
  );
};

export default NewSave;
